<template lang="pug">
  v-card(
    v-on="$listeners"
  ).cardPowerBall
    slot
      v-row(style="min-height: 30px;" justify="center" align="center" v-if="src || text")
        v-img(:src="src" v-if="src").imgCardPowerBall
        h5.white--text.ml-1.single-line.font-weight-power-ball(
          v-if="text" 
        ) {{ text }}
</template>
<script>
export default {
  props: {
    src:{
      type: String,
      default:null
    },
    text:{
      type: String,
      default:null
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 960px) { 
  .imgCardPowerBall {
    max-width: 20px !important;
  }
  .cardPowerBall {
    padding: 6px !important;
  }
}
.imgCardPowerBall {
  max-width: 30px;
}
.cardPowerBall { 
  border-radius: 16px;
  padding: 16px;
  background-image: linear-gradient(180deg, var(--card-power-ball-v2), var(--card-power-ball-2-v2));
}
.single-line {
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>